
import { defineComponent, inject } from 'vue';
import { useVModel } from 'vue-composable';
import { WarningOutline as WarningIcon } from '@vicons/ionicons5';
import { ShowToast } from '@/providers/Toast/toast-types';
import { FormResponse, SendInviteStatus } from '@/types/response';
import responseService from '@/services/response-service';

const NOT_SENT_TOASTS: Record<Exclude<SendInviteStatus, 'sent'>, (email: string) => { headline: string; message: string }> = {
  alreadyInvited: (email) => ({ headline: 'Already invited', message: `${email} was invited by another send just now.` }),
  failed: (email) => ({ headline: 'Resend failed', message: `The survey couldn't be sent to ${email}. Try again.` })
};

export default defineComponent({
  name: 'ConfirmSurveyResendModal',
  props: {
    response: {
      type: Object as () => FormResponse | null,
      required: true
    },
    showModal: {
      type: Boolean,
      required: true
    }
  },
  components: { WarningIcon },
  setup(props) {
    const showModalRef = useVModel(props, 'showModal');
    const showToast = inject<ShowToast>('showToast')!;
    const confirmResend = async () => {
      const updated = props.response as FormResponse;
      updated.completedOn = null;
      if (props.response === null) return;
      const { status } = await responseService.create(props.response?.surveyId, props.response);
      if (status !== 'sent') {
        // Left open so the admin can retry.
        showToast({ ...NOT_SENT_TOASTS[status](props.response.email), color: 'warning' });
        return;
      }
      showToast({
        headline: 'Success',
        message: 'Survey resent',
        color: 'success'
      });
      showModalRef.value = false;
    };

    const cancelUnlock = () => {
      showModalRef.value = false;
    };

    return {
      confirmResend,
      cancelUnlock,
      showModalRef
    };
  }
});
